import type { ForjaStep } from '@mxa-argos/modules/forja/interfaces/forja-step.interface';
import { wifiOffStep } from '@mxa-argos/modules/forja/lib/provisioning/steps/wifi.steps';

export function postKioskSteps(): ForjaStep[] {
  return [wifiOffStep()];
}
